module.exports = __webpack_public_path__ + "static/media/11.833f13d5.jpg";